import React from 'react';

const SITE_URL = 'https://summaros.com';

const SEO = ({
  title,
  description,
  path = '/',
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title?.toLowerCase().includes('summaros')
    ? title
    : `${title} · Summaros`;
  const url = `${SITE_URL}${path}`;
  const desc = description || 'Summaros — a Life Intelligence platform. Understand your whole life.';

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Summaros" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </>
  );
};

export default SEO;
